import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import PaymentReceipt from '../../../../components/card/paymentReceipt/paymentReceipt';
import { PAYMENT_ID, PAYMENT_VALUE } from '../../../../config/cacheKey';
import { changeRouteType, getpervInnerState } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../../../redux/headerTitle/headerTitleSlice';
import './resultPayment.css';

export default function Payment({ referenceKey, setStep, parentRoute = 'AssignedLoans' }: any) {

    // const [paymentArray, setPaymentArray] = useState<[]>([]);
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    useEffect(() => {
        queryClient.setQueryData(PAYMENT_ID, 1);
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'رسید پرداخت', parentRoute: parentRoute }));
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: parentRoute }));
        // setPaymentArray(queryClient.getQueryData(PAYMENT_VALUE)!);
    }, [])
    return (
        <div className='container-height-without-drawer mt-14'>
            <PaymentReceipt />
            {/* <Card className="!shadow-none cardContainer">
                <Grid container xs={12}>
                    <Grid
                        item
                        xs={12}
                        textAlign={'center'}
                        className="!pb-2 primaryColorLight-900 yekanBakhFaNum"
                    >
                        <div className="yekanBakhFaNum mt-2 primaryColorLight-900">
                            <span>8000000 ریال</span>
                        </div>
                        <div className="bgSecondaryColorLight badge mt-3">
                            <CheckCircleIcon />
                            &nbsp;پرداخت موفق
                        </div>
                        {setStep !== 'payment' ?

                            <div className="mt-5 mb-5" style={{ fontSize: '.9em' }}>
                                لطفا جهت تکمیل فرآیند ثبت درخواست دکمه <span className='secondaryColorLight-600' >"ادامه"</span> را
                                بزنید
                            </div> : <div className="mt-5 mb-5"></div>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <hr className="indented-hr" />
                    </Grid>
                    <Grid
                        item
                        container
                        xs={12}
                        textAlign={'center'}
                        className="!pt-3 primaryColorLight-900 yekanBakhFaNum"
                    >
                        {paymentArray?.map((item: any, index: number) => (
                            <Grid container xs={12} key={index} className="mt-5">
                                <Grid item xs={6} textAlign={'right'}>
                                    {item?.title}
                                </Grid>
                                <Grid item xs={6} textAlign={'left'}>
                                    {item?.value}
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Card> */}
        </div>
    );
}
